import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "power-log custom-scroll"
};
const _hoisted_2 = {
  class: "inner"
};
const _hoisted_3 = {
  class: "list-box"
};
const _hoisted_4 = {
  class: "handle-box"
};
const _hoisted_5 = {
  class: "pagination"
};
import nodata from "@/assets/img/no-data.png";
import { onMounted, ref } from "vue";
import { dateFormat } from "@/utils/libs";
import { Search } from "@element-plus/icons-vue";
import Clipboard from "clipboard";
import { ElMessage } from "element-plus";
import { httpPost } from "@/utils/http";
import { checkSession } from "@/store/cache";
export default {
  __name: 'PowerLog',
  setup(__props) {
    const items = ref([]);
    const total = ref(0);
    const page = ref(1);
    const pageSize = ref(20);
    const loading = ref(false);
    const listBoxHeight = window.innerHeight - 87;
    const query = ref({
      model: "",
      date: []
    });
    const tagColors = ref(["primary", "success", "primary", "danger", "info", "warning"]);
    onMounted(() => {
      checkSession().then(() => {
        fetchData();
      }).catch(() => {});
      const clipboard = new Clipboard(".copy-order-no");
      clipboard.on("success", () => {
        ElMessage.success("复制成功！");
      });
      clipboard.on("error", () => {
        ElMessage.error("复制失败！");
      });
    });

    // 获取数据
    const fetchData = () => {
      loading.value = true;
      // httpPost("/powerLog/list", {
      httpPost("/ai/user-power-logs/list", {
        model: query.value.model,
        date: query.value.date,
        page: page.value,
        pageSize: pageSize.value
      }).then(res => {
        if (res.list) {
          items.value = res.list;
          total.value = res.total;
          page.value = res.page;
          pageSize.value = res.pageSize;
        }
        loading.value = false;
      }).catch(e => {
        loading.value = false;
        ElMessage.error("获取数据失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_empty = _resolveComponent("el-empty");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
        modelValue: query.value.model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => query.value.model = $event),
        placeholder: "模型",
        class: "handle-input mr10",
        clearable: ""
      }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
        modelValue: query.value.date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => query.value.date = $event),
        type: "daterange",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        format: "YYYY-MM-DD",
        "value-format": "YYYY-MM-DD",
        style: {
          "margin": "0 10px",
          "width": "200px"
        }
      }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        icon: _unref(Search),
        onClick: fetchData
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["icon"])]), items.value.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: items.value,
          "row-key": row => row.id,
          "table-layout": "auto",
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "model",
            label: "模型",
            width: "130px"
          }), _createVNode(_component_el_table_column, {
            prop: "type",
            label: "类型"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_tag, {
              size: "small",
              type: tagColors.value[scope.row.type]
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.type_str), 1)]),
              _: 2
            }, 1032, ["type"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "数额"
          }, {
            default: _withCtx(scope => [_createElementVNode("div", null, [scope.row.mark === 1 ? (_openBlock(), _createBlock(_component_el_text, {
              key: 0,
              type: "success"
            }, {
              default: _withCtx(() => [_createTextVNode("+" + _toDisplayString(scope.row.amount), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true), scope.row.mark === 0 ? (_openBlock(), _createBlock(_component_el_text, {
              key: 1,
              type: "danger"
            }, {
              default: _withCtx(() => [_createTextVNode("-" + _toDisplayString(scope.row.amount), 1)]),
              _: 2
            }, 1024)) : _createCommentVNode("", true)])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "balance",
            label: "余额"
          }), _createVNode(_component_el_table_column, {
            label: "发生时间",
            width: "160px"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(_unref(dateFormat)(scope.row["created_at"])), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "备注"
          })]),
          _: 1
        }, 8, ["data", "row-key"]), _createElementVNode("div", _hoisted_5, [total.value > 0 ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 0,
          background: "",
          layout: "prev, pager, next",
          style: {
            "--el-pagination-button-bg-color": "rgba(86, 86, 95, 0.2)"
          },
          "hide-on-single-page": false,
          "current-page": page.value,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = $event => page.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = $event => pageSize.value = $event),
          onCurrentChange: _cache[4] || (_cache[4] = $event => fetchData()),
          total: total.value
        }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])]),
        _: 1
      })) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 100,
        image: _unref(nodata),
        description: "暂无数据"
      }, null, 8, ["image"]))])])])), [[_directive_loading, loading.value]]);
    };
  }
};